module.exports = __webpack_public_path__ + "static/Figma-f5587fa1f8f1a32b3f0cd578a3954a62.jpg";